import{useMemo as t}from"react";function n(e){return t(()=>e,Object.values(e))}export{n as useSlot};
